// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"f552d4a1","536":"4a303ad0","834":"0de022d7"}[chunkId] + ".chunk.js";
};